import React from 'react';

const SortableHeader = ({ label, field, sortField, sortOrder, onSort }) => {
  const isActive = sortField === field;
  const currentOrder = sortOrder;

  let iconClass = 'bi bi-filter'; // neutral sort icon
  if (isActive) {
    iconClass = currentOrder === 1 ? 'bi bi-sort-down' : 'bi bi-sort-up';
  }

  const handleClick = () => {
    const nextOrder = isActive && currentOrder === 1 ? -1 : 1;
    onSort({ sortField: field, sortOrder: nextOrder });
  };

  return (
    <span
      style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}
      onClick={handleClick}
    >
      {label}
      {isActive && (
        <i
          className={`${iconClass} ms-2`}
          style={{ marginLeft: '0.5rem', fontSize: '1rem', width: '1rem', height: '1rem' }}
        />
      )}
    </span>
  );
};

export default SortableHeader;
